import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import type { DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';
import type { ClientFindInterface } from '@zaoblako/shared/modules/client/dtos/client/client-find.dto';
import type { SubprojectDefaultsFormInterface } from '@zaoblako/shared/modules/project/dto/subproject-defaults/subproject-defaults-form.dto';
import type { UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';
import { ClientService } from '@zaoblako/web/core/services/client/client.service';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { DirectionService } from '@zaoblako/web/core/services/finance/direction.service';
import { ProjectService } from '@zaoblako/web/core/services/project/project.service';
import { UserGroupService } from '@zaoblako/web/core/services/security/user-group.service';
import { ProjectStoreService } from '@zaoblako/web/modules/project/components/project/card/services/project-store.service';
import { SubprojectDefaultsFormComponent } from '@zaoblako/web/modules/project/dumbs/subproject-defaults-form/subproject-defaults-form.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { forkJoin } from 'rxjs';

@Component({
  standalone: true,
  selector: 'crm-subproject-defaults-fill-modal',
  templateUrl: './subproject-defaults-fill-modal.component.html',
  imports: [CommonModule, SubprojectDefaultsFormComponent, SpinnerComponent, ButtonModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubprojectDefaultsFillModalComponent implements OnInit {
  public commonLoading = false;
  public subprojectDefaults: SubprojectDefaultsFormInterface;
  public loading = false;

  public directions: DirectionFindInterface[] = [];
  public clients: ClientFindInterface[] = [];
  public userGroups: UserGroupFindInterface[] = [];

  public parentId: number;
  public parentProjectName: string;

  public constructor(
    private readonly config: DynamicDialogConfig,
    public readonly ref: DynamicDialogRef,
    private readonly userGroupService: UserGroupService,
    private readonly clientService: ClientService,
    private readonly directionService: DirectionService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly projectService: ProjectService,
    private readonly projectStoreService: ProjectStoreService,
    private readonly errorService: ErrorService
  ) {
    this.subprojectDefaults = config.data?.subprojectDefaults;
    this.parentId = config.data?.parentId;
    this.parentProjectName = config.data?.parentProjectName;
  }

  public ngOnInit() {
    this.commonLoading = true;
    this.cdRef.markForCheck();

    forkJoin([
      this.directionService.find<DirectionFindInterface>(),
      this.userGroupService.find<UserGroupFindInterface>(),
      this.clientService.findAll()
    ]).subscribe(([directions, userGroups, clients]) => {
      this.directions = directions;
      this.userGroups = userGroups;
      this.clients = clients;
      this.commonLoading = false;
      this.cdRef.markForCheck();
    });
  }

  public changeDefaults(defaults: SubprojectDefaultsFormInterface) {
    this.loading = true;
    this.projectService.updateSubprojectDefaults(this.parentId, defaults).subscribe({
      next: (defaults) => {
        this.projectStoreService.updateDefaults(defaults);
        this.errorService.addSuccessMessage(`Реквизиты для задачи "${this.parentProjectName}" обновлены`);
        this.loading = false;
        this.cdRef.markForCheck();
      },
      error: () => {
        this.loading = false;
        this.cdRef.markForCheck();
      }
    });
  }
}
